export const API_NAME = "ai";
export const ROUTE_NAME = "ai";
export const COMPONENT_NAMES = ["setting", "settings"];
